import { renderRoutes } from 'react-router-config';
import { useEffect } from 'react';
import { useWebsiteInfo } from './useWebsiteInfo';
import { Spin } from 'antd';
import { secureApi } from '../../../hooks/api';
import { url } from '../../../constants/api';
export default function EditWebsite({ route, match }) {
  const { setWebsiteInfo, websiteInfo } = useWebsiteInfo();

  useEffect(() => {
    secureApi(url(`website-configurations/${match.params.key}/get`)).then(
      (data) =>
        setWebsiteInfo({
          ...data,
          websiteId: match.params.key,
        })
    );
  }, []);
  return !websiteInfo ? <Spin size="large" /> : renderRoutes(route.routes);
}

EditWebsite.url = 'website/:key';
